module.exports = "/_next/static/images/a3fa6893d14c027a7c81719705d81d2f-app-screenshots-lg@3x.jpg.webp";